import React from 'react';
import { Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import Icon from '../../../components/AppIcon';

const ActivityTimelineChart = ({ timelineData }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-forensic-modal">
          <p className="text-sm font-medium text-text-primary">{label}</p>
          <p className="text-sm text-text-secondary">
            Transactions: {payload?.[0]?.value}
          </p>
          <p className="text-sm text-text-secondary">
            Volume: {payload?.[1]?.value || 0} BTC
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-forensic-card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-text-primary">Activity Timeline</h3>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-primary rounded-full" />
            <span className="text-sm text-text-secondary">Transaction Count</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-accent rounded-full" />
            <span className="text-sm text-text-secondary">Volume (BTC)</span>
          </div>
        </div>
      </div>

      <div className="h-64 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={timelineData}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="date" 
              stroke="var(--color-text-secondary)"
              fontSize={12}
            />
            <YAxis 
              yAxisId="left"
              stroke="var(--color-text-secondary)"
              fontSize={12}
            />
            <YAxis 
              yAxisId="right"
              orientation="right"
              stroke="var(--color-text-secondary)"
              fontSize={12}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              yAxisId="left"
              type="monotone"
              dataKey="transactionCount"
              stroke="var(--color-primary)"
              fill="var(--color-primary)"
              fillOpacity={0.1}
              strokeWidth={2}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="volume"
              stroke="var(--color-accent)"
              strokeWidth={2}
              dot={{ fill: 'var(--color-accent)', strokeWidth: 2, r: 4 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-muted p-3 rounded-lg">
          <div className="text-sm text-text-secondary">Peak Activity</div>
          <div className="text-lg font-semibold text-text-primary">Mar 15, 2024</div>
          <div className="text-xs text-text-secondary">247 transactions</div>
        </div>
        <div className="bg-muted p-3 rounded-lg">
          <div className="text-sm text-text-secondary">Dormancy Period</div>
          <div className="text-lg font-semibold text-text-primary">45 days</div>
          <div className="text-xs text-text-secondary">Jun-Jul 2024</div>
        </div>
        <div className="bg-muted p-3 rounded-lg">
          <div className="text-sm text-text-secondary">Avg. Daily Volume</div>
          <div className="text-lg font-semibold text-text-primary">12.5 BTC</div>
          <div className="text-xs text-text-secondary">Last 30 days</div>
        </div>
      </div>
    </div>
  );
};

export default ActivityTimelineChart;